import React, { useContext, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getBrandPageContentCall } from '@kfc-global/react-shared/redux/Actions/BrandPageAction';
import {
  getHeaderData,
  isEmptyObject,
  getFooterData,
  isMobileDevice,
  getHeaderContentData,
} from 'common/utilities/utils';
import Header from 'organisms/HeaderComponent/Container/HeaderContainer';
import { Footer } from 'organisms/FooterComponent';
import { getCmsClient } from 'common/utilities/cmsClient';
import PageDescription from 'organisms/BrandPage/Presentation/PageDescription';
import { modifyData } from 'organisms/MarketingHero/MarketingUtilities/marketingUtils';
import RegionalMarketingItems from 'organisms/MarketingHero/Presentation/RegionalMarketingItems';
import isEmpty from 'lodash/isEmpty';
import { StartOrderComponent } from 'organisms/StartOrderComponent';
import HOME_PAGE_CONTAINER_CONSTANTS from '../../../homePageContainer/Constants/homePageContainerConstants';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { BrandPageTemplates } from 'app/Constants';
import { getMarketConfigContent } from 'common/utilities/content';
import { StructureData } from '../../../../organisms/StructureDataComponent';
import { UserOrderContext } from 'context/context';
import HEADER_CONSTANT from 'organisms/HeaderComponent/AU/HeaderConstants/HeaderConstant';
import { CAUTION_NOTICE_URL } from 'common/constants/SharedConstants';

const GeneratedBrandPageContainer = props => {
  const { routePath, hideNav } = props;
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const history = useHistory();
  const { marketPageContent, tenantReducerContent, userParams, brandPageContent, homePageContent } = useSelector(
    data => {
      return {
        marketPageContent: data.marketConfigReducer?.response,
        tenantReducerContent: data.tenantReducer,
        userParams: data.appStateReducer?.userStatus,
        brandPageContent: data.brandPageReducer?.response,
        homePageContent: data.contentReducer?.response,
      };
    },
  );
  const { header = {}, footer = {} } = marketPageContent.headerData ?? {};
  const { headerData: brandedData = {} } = brandPageContent ?? {};
  const {
    carousalContent: { fields: { carousalContent = '' } = {} } = {},
    seoPage: { fields: { title: seoPage = '' } = {} } = {},
  } = brandedData;
  const carauselContent = (carousalContent && modifyData(carousalContent)) ?? [];
  const segmentedMarketingData = getHeaderData(header);
  const segmentedFooterData = getFooterData(footer);
  const segmentedHomePageData = getHeaderContentData(homePageContent) ?? {};
  const dispatch = useDispatch();
  const { DISPOSITION } = HOME_PAGE_CONTAINER_CONSTANTS;

  const generatedComponent = (
    <>
      {(isEmptyObject(carauselContent) && (
        <div className='market-hero'>
          <RegionalMarketingItems contentData={carauselContent} isMobile={isMobile} />
        </div>
      )) ??
        null}

      <PageDescription {...brandedData} />
    </>
  );

  /**
   * Method call on window resize
   */
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setIsMobile(isMobileView);
  };

  /**
   * RENDEV-15294 this use effect is over riding the url /about-kfc/caution-notice title only
   * brandedData we are getting from api
   */
  useEffect(() => {
    if (brandedData.title && routePath && routePath === CAUTION_NOTICE_URL) {
      document.title = brandedData.title;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandedData.title]);

  /**
   * Use to add window listener for window size change
   */
  useEffect(() => {
    window.addEventListener('resize', windowResized);
    return () => {
      window.removeEventListener('resize', windowResized);
    };
  }, [isMobile]);

  useEffect(() => {
    userOrderStateDispatch({ type: HEADER_CONSTANT.SET_HIDE_DISPOSITION_BAR, value: { hideDispositionBar: true } });
    return () => {
      userOrderStateDispatch({ type: HEADER_CONSTANT.SET_HIDE_DISPOSITION_BAR, value: { hideDispositionBar: false } });
    };
  }, [userOrderStateDispatch]);

  useEffect(() => {
    if (routePath) {
      dispatch(
        getBrandPageContentCall({
          object: getCmsClient(),
          contentFull: {
            content_type: BrandPageTemplates.Template2,
            'fields.routePath': routePath,
            include: 5,
          },
        }),
      );
    }
  }, [dispatch, routePath]);

  useEffect(() => {
    dispatch(getMarketConfigContent(tenantReducerContent));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, tenantReducerContent?.country]);

  return (
    <>
      {!isEmpty(seoPage) && <StructureData page={seoPage} />}
      {segmentedMarketingData && (!hideNav || hideNav === false) && (
        <Header contentData={segmentedMarketingData} tenantReducerData={tenantReducerContent} userParams={userParams} />
      )}
      <StartOrderComponent
        contentData={{
          segmentedHomePageData: segmentedHomePageData?.[DISPOSITION],
          contentDispositionData: segmentedHomePageData?.[DISPOSITION],
        }}
        userParams={userParams}
        showHeader={false}
      />
      {!isEmpty(brandedData) && generatedComponent}
      {segmentedFooterData && (!hideNav || hideNav === false) && (
        <Footer history={history} contentData={segmentedFooterData} tenantReducerData={tenantReducerContent} />
      )}
    </>
  );
};

GeneratedBrandPageContainer.propTypes = {
  history: PropTypes.object,
  routePath: PropTypes.string.isRequired,
};

GeneratedBrandPageContainer.defaultProps = {
  history: {},
};

export default GeneratedBrandPageContainer;
